
import { defineComponent } from "vue";
import FirstView from "./components/FirstView.vue";
import Intro from "./components/Intro.vue";
import Learn from "./components/Learn.vue";
import VrArt from "./components/VrArt.vue";
import Scroll from "./components/Scroll.vue";
import Presenter from "./components/Presenter.vue";
import About from "./components/About.vue";

export default defineComponent({
  name: "App",
  components: {
    FirstView,
    Intro,
    Learn,
    VrArt,
    Scroll,
    Presenter,
    About,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    scroll(target: string): void {
      const element: any = document.getElementById(target);
      const rectTop: number = element.getBoundingClientRect().top;
      const distance: number = window.pageYOffset + rectTop;
      window.scrollTo({
        top: distance,
        behavior: "smooth",
      });
      this.isOpen = false;
    },
  },
});
